<template>
    <div class="consulting-item-padding" @click="$emit('item-click', item)">
        <div class="consulting-item-bg">
            <div class="consulting-item-title van-ellipsis">
                <span class>{{ item.title }}</span>
            </div>
            <div class="consulting-item-content-wrap">
                <div class="consulting-item-content">
                    <div class="consulting-item-content-intro van-multi-ellipsis--l2">
                        {{ item.intro || item.extra }}
                    </div>
                    <p class="consulting-item-content-date">
                        {{ item.own_time || item.showDate || item.ownTime }}
                    </p>
                </div>
                <van-image
                    class="consulting-item-cover"
                    alt="封面图片"
                    lazy-load
                    :src="item.cover"
                />
            </div>
        </div>
    </div>
</template>

<script>
// import { Image } from 'vant'
export default {
    name: 'ConsultingItem',
    components: {
        // 'van-image': Image
    },
    props: {
        item: {
            type: Object,
            required: true,
            default: {}
        }
    },
    data() {
        return {}
    },
    computed: {
        // intro_height() {
        //     return os.isPC() ? '1.2rem' : '1.6rem'
        // }
    },
    created() {},
    methods: {}
}
</script>
<style scoped lang="scss">
@import '@styles/variables.scss';

.consulting-item-padding {
    width: 100%;
    padding: 0.62rem 0rem;
    border-bottom: 1px solid #dddddd;
}
.consulting-item-bg {
    width: 100%;
    height: 4.1rem;
    display: flex;
    flex-direction: column;

    cursor: pointer;
}

.consulting-item-title {
    flex-direction: row;
    // margin-top: 0.3rem;
    // height: 0.7rem;
    overflow: hidden;

    span {
        color: #222222;
        font-weight: bold;
        font-size: $fsxl;
    }
}

.consulting-item-content-wrap {
    margin-top: 0.3rem;
    display: flex;
    flex-direction: row;
}

.consulting-item-content {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    flex: 1;
    margin-right: 0.9rem;
}

.consulting-item-content-intro {
    word-break: break-all;
    font-size: $fslg;
    color: #888888;
}

.consulting-item-content-date {
    margin-top: 0.2rem;
    font-size: $fslg;
    color: #888;
}

.consulting-item-cover {
    width: 5.9rem;
    height: 2.96rem;
    border-radius: 4px;
    box-shadow: 0px 5px 5px rgba(206, 206, 206, 0.6);
}
.consulting-item-cover ::v-deep {
    img {
        border-radius: 4px;
    }
}
.meet_item_title {
    flex-direction: row;
    word-break: break-all;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    height: 1.96rem;
    overflow: hidden;
}
</style>
